// extracted by mini-css-extract-plugin
export default {"reset_date":"styles_reset_date__OaZfB"};